"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentContainerSize = void 0;

var getParentContainerSize = function getParentContainerSize(img) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'width';
  var parentNode = img;
  var size = 0;
  var maxCount = 0;

  do {
    parentNode = parentNode && parentNode.parentNode;
    size = parentNode && typeof parentNode.getBoundingClientRect === 'function' ? parentNode.getBoundingClientRect()[type] : 0;
    maxCount = maxCount + 1;
  } while (parentNode && !size && maxCount <= 5);

  if (type === 'width') {
    if (!size) {
      size = window.innerWidth;
    } else if (parentNode.nodeType === 1) {
      var computedStyle = window.getComputedStyle(parentNode);
      var leftPadding = parseInt(computedStyle.paddingLeft) || 0;
      var rightPadding = parseInt(computedStyle.paddingRight) || 0;
      size -= leftPadding + rightPadding;
    }
  }

  return size;
};

exports.getParentContainerSize = getParentContainerSize;